const AnnualReportNoticeSource = {
    BZP: "BZP",
    TED: "TED",
}

export default AnnualReportNoticeSource;